import { useQuery } from '@apollo/client';
import { useRouter } from '@application/utils';
import { graphql } from '@gql/gql';
import type { ProLandingGetGroomersQuery, ProLandingGetGroomersQueryVariables } from '@gql/graphql';
import { ProfessionalTypeEnum, SortOrder } from '@gql/graphql';
import { useMemo } from 'react';

export const PRO_LANDING_GET_GROOMERS = graphql(`
  query ProLandingGetGroomers(
    $orderBy: [ProfessionalOrderByWithRelationAndSearchRelevanceInput!]
    $where: ProfessionalWhereInput
    $take: Int
    $imgsTake: Int
    $translationsWhere: ProTranslationWhereInput
  ) {
    searchProfessionals(orderBy: $orderBy, where: $where, take: $take) {
      professionals {
        id
        namePro
        mainProFirstName
        mainProLastName
        type
        imgs(take: $imgsTake) {
          id
          small
        }
        translations(where: $translationsWhere) {
          id
          url
          title
        }
        address {
          id
          zip
          city
        }
      }
    }
  }
`);

export const useGetGroomers = () => {
  const { language } = useRouter();

  const variables = useMemo((): ProLandingGetGroomersQueryVariables => {
    return {
      where: {
        AND: [
          { type: { equals: ProfessionalTypeEnum.GROOMER } },
          { unclaimedProfile: { equals: false } },
          { published: { equals: true } },
        ],
      },
      imgsTake: 1,
      take: 4,
      orderBy: [{ createdAt: SortOrder.desc }],
      translationsWhere: { language: { equals: language } },
    };
  }, [language]);

  const { data, error, loading } = useQuery<
    ProLandingGetGroomersQuery,
    ProLandingGetGroomersQueryVariables
  >(PRO_LANDING_GET_GROOMERS, { variables });

  return {
    groomers: data?.searchProfessionals.professionals ?? [],
    groomersError: error,
    groomersLoading: loading,
    groomersVariables: variables,
  };
};
